import { ChannelActions, PollActions } from "@Store";
import { Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { actions as DialogActions } from "@Store/Reducers/dialog";
import { useTranslation } from "react-i18next";

type PollModalTypes = {
    pollId: string;
    channelId: string;
};

const DeletePollContent: React.FC = () => {
    const { t } = useTranslation();
    return <>{t("dialogs.delete_poll")}</>;
};

const DeletePollActions: React.FC<PollModalTypes> = ({ pollId, channelId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<any>();
    const handleDeletePoll = () => {
        dispatch(PollActions.deletePoll(pollId, channelId));
        dispatch(ChannelActions.fetchChannelPolls(channelId));
        dispatch(DialogActions.hideDialog());
    };

    return (
        <>
            <Button
                onClick={handleDeletePoll}
                variant="contained"
                size="small"
                color="secondary"
                type="submit"
            >
                {t("dialogs.delete")}
            </Button>
        </>
    );
};

export default {
    content: DeletePollContent,
    actions: DeletePollActions,
    title: "Delete Channel Poll",
};
